export default __webpack_public_path__ + "static/972-38779a0f6a4bbc31686a4875d723c76f.gif";